import $ from "jquery";
import { capitalize } from "lodash";
import {  SIZE_DATA, state } from "../../core/settings";
import { addToCartButtonComponent, refreshCartTotal } from "../summary/summary-button/summaryButton";
import interfaceHTML from "./interface.html";
import "./interface.scss";
import { interfaceGroupComponent } from "./interfaceItems/interfaceGroup/interfacGroup";
import {
  interfaceGroupInputsComponent,
  typesInputs,
  updateTextParam,
  buildSummaryContent,
} from "./../interface/interfaceItems/interfaceGroup/interfaceGroupInputs/interfaceGroupInputs";
import { typesDirection } from "./interfaceItems/interfaceGroup/interfaceGroupInputs/range/generateRange";

export const step = !state.model ? 17 : 20;

const textWall = updateTextParam(state, this, false, true);
const textElectro = updateTextParam(state, this, true, true);

export function deleteActiveClassFromContainerRadioType(
  container,
  firstSelector,
  activeClass
) {
  container.find(firstSelector).each(function () {
    $(this).closest(firstSelector).removeClass(activeClass);
  });
}

export const countryType = {
  0: "Belgium",
  1: "France",
};

export const shapeType = {
  0: "Straight walls",
  1: "Sloping walls",
  2: "Extra-high walls",
};

export const installationType = {
  0: "Yes",
  1: "No",
};


export const groups = [
  {
    title: "Choose your country",
    param: countryType[state.countryType],
    type: typesInputs.countryType,
  },
  {
    title: "Shape",
    param: shapeType[state.shapeType],
    type: typesInputs.shapeType,
  },
  {
    title: "Size",
    param: (() => {
      const sizes = SIZE_DATA[state.shapeType];
      if (!sizes || !sizes.length) return "—";
      const s = sizes[state.sizeIndex] ?? sizes[0];
      if (!s) return "—";
      return `${s.code} - ${s.width} x ${s.length}m`;
    })(),
    type: typesInputs.size,
  },
  {
    title: "Color",
    param: state.colorBody,
    type: typesInputs.colorFrame,
  },
  { title: "Accessories", param: "", type: typesInputs.accessories },
  {
    title: "Installation",
    param: "",
    type: typesInputs.installation,
    condition: () => state.countryType === 0,
  },
  {
    title: "Summary",
    param: "",
    type: typesInputs.summary,
  },
];

export function interfaceComponent(container) {
  const componentContent = $(
    '<div class="interface-container" id="interface"></div>'
  );

  const interfaceElement = $(interfaceHTML);

  groups.forEach((group) => {
    const groupComponent = interfaceGroupComponent(group.title, group.param);
    groupComponent.attr('data-group-type', group.type);

    const groupComponentInputs = $(
      '<div class="interface__group__inputs"></div>'
    );
    groupComponentInputs.append(
      interfaceGroupInputsComponent(
        group.type,
        group?.ranges,
        group?.initValuePostSize,
        group.title
      )
    );
    groupComponent.append(groupComponentInputs);

    groupComponentInputs.hide();

    if (group.condition && !group.condition()) {
      groupComponent.hide();
    }

    interfaceElement.append(groupComponent);
  });

  // Refresh summary content each time its group is opened
  const $summaryGroup = interfaceElement.find(`[data-group-type="${typesInputs.summary}"]`);
  $summaryGroup.find('.interface__group__head').on('click', function () {
    $summaryGroup.find('.type_interface_summary').replaceWith(buildSummaryContent());
    refreshCartTotal();
  });

  // When the window mode toggle changes, refresh summary and cart total if summary is open
  window.addEventListener('windowModeChanged', () => {
    const $sum = $summaryGroup.find('.type_interface_summary');
    if ($sum.length) {
      $sum.replaceWith(buildSummaryContent());
      refreshCartTotal();
    }
  });

  // When an accessory is placed or removed externally (e.g. deleted in popup),
  // refresh summary and cart total if the summary panel is currently open
  window.addEventListener('accessoryPlaced', () => {
    const $sum = $summaryGroup.find('.type_interface_summary');
    if ($sum.length) {
      $sum.replaceWith(buildSummaryContent());
    }
    refreshCartTotal();
  });

  $(componentContent).append(interfaceElement);

  addToCartButtonComponent(componentContent);
  $(container).append(componentContent);
}
